import { CoverageAssistantFilters } from '@procureai/ui-modules-mui';
import { addMonths, addYears, startOfMonth } from 'date-fns';
import { z } from 'zod';

const commodityUndercoverageSchemaSelected = z.object({
  selected: z.literal(true),
  rowId: z.string(),
  commodityId: z.string(),
  commodityGroupId: z.string().optional(),
  organizationId: z.string(),
  undercoveredQuantity: z.number(),
  unitId: z.string(),
  priceUnit: z.number(),
  validFrom: z.string(),
  validTo: z.string(),
  currency: z.string(),
  minimumOrderQuantity: z.number(),
  qualifiedSupplierIds: z.array(z.string()),
  title: z.string().optional(),
  description: z.string().optional(),
  baselinePricePerPriceUnit: z.number(),
  rowIndex: z.number().optional(),
});

const commodityUndercoverageSchemaUnselected = commodityUndercoverageSchemaSelected.extend({
  selected: z.literal(false).optional(),
  baselinePricePerPriceUnit: z.number().optional(),
});

const commodityUndercoverageSchema = z.discriminatedUnion('selected', [
  commodityUndercoverageSchemaUnselected,
  commodityUndercoverageSchemaSelected,
]);

export const commodityUndercoveragesSchema = z.object({
  summary: z.string().trim().min(1, { message: 'widgets:CoverageAssistantWidget.summaryRequired' }),
  predictions: z.array(commodityUndercoverageSchema),
});

export type CommodityUndercoverage = z.infer<typeof commodityUndercoverageSchema>;
export type CommodityUndercoverages = z.infer<typeof commodityUndercoveragesSchema>;

export const coverageAssistantFiltersDefault: CoverageAssistantFilters = (() => {
  const beginningOfNextMonth = startOfMonth(addMonths(new Date(), 1));
  return {
    timeframe: [beginningOfNextMonth, addYears(beginningOfNextMonth, 1)],
    commodityGroups: [],
    organizations: [],
    commodities: [],
  };
})();
